import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2ff4bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      class: _normalizeClass(`${_ctx.textColor} ${_ctx.colorClass} ${_ctx.sizeClass}`)
    }, " " + _toDisplayString(_ctx.versionText), 3),
    _createElementVNode("a", {
      target: "_blank",
      class: _normalizeClass(`${_ctx.textColor} ${_ctx.colorClass} ${_ctx.sizeClass}`),
      href: _ctx.COPYRIGHT_URI
    }, _toDisplayString(_ctx.$t("app_copyright")), 11, _hoisted_1)
  ], 64))
}